import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import ICON from '@tencent/docs-design-resources/icon/mobile/svg/time_outline_regular_24.svg';

export const config = {
    id: ActionType.TRANSITION_DURATION,
    icon: ICON,
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        hasArrow: true,
        preventHighlight: true,
        tooltip: i18n.t('持续时间'),
    },
];

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        icon: <img src={config.icon} alt={''}/>,
        tooltip: i18n.t('持续时间'),
    },
];
